<template>
    <div>
        <div style="padding: 10px">
            <img src="@/assets/logo.png" alt="MyDocPort" style="max-width: 100%; max-height: 100px; cursor: pointer"
                @click="$router.push('/dashboard')" />
            <div class="text-center">
                Administration Portal
            </div>
        </div>

        <div v-for="(item, i) in items" :key="i">
            <v-list-item-group v-if="item.children && checkPermissions(item.permission)" v-model="item.model"
                :key="item.text + '-group'" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
                <v-list-item slot="activator">
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.route">
                    <v-list-item-icon v-if="child.icon">
                        <v-icon>{{ child.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ child.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
            <v-list-item-group v-else-if="checkPermissions(item.permission)">
                <v-list-item :key="item.text" :to="item.route">
                    <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </div>
    </div>
</template>

<script>
import { authGate } from '@/mixins/authGate'

export default {
    name: 'NavMenu',
    mixins: [authGate],
    data: () => ({
        items: [
            { icon: 'mdi-view-dashboard', text: 'Dashboard', route: '/dashboard' },
            {
                icon: 'mdi-clipboard-list',
                text: 'Projects',
                route: '/projects',
            },
            { icon: 'mdi-database', text: 'Content', route: '/output' },
            { icon: 'mdi-domain', text: 'Clients', route: '/clients' },
            { icon: 'mdi-account-multiple', text: 'Users', route: '/users' },
            { icon: 'mdi-wallet-bifold', text: 'Subscriptions', route: '/subscriptions' },
            // HIDE FOR NOW, PENDING DECISION ON IMPLEMENTATION
            // {
            //     icon: 'mdi-newspaper-variant-outline',
            //     text: 'Variables',
            //     route: '/variables',
            // },
            {
                icon: 'mdi-bell',
                text: 'Notifications',
                route: '/notifications',
            },
        ],
    }),
}
</script>
